import React, { Suspense } from 'react';
import { Element } from 'react-scroll';
import { CSSReset, Spinner, Center } from '@chakra-ui/react';


const Header = React.lazy(() => import('../Components/Home/header'));
const NewsOverview = React.lazy(() => import('../Components/Home/NewsOverview'));
const ApplicationsSection = React.lazy(() => import('../Components/Home/ApplicationsSection'));
const ProductsOverview = React.lazy(() => import('../Components/Home/ProductsOverview'));
const ContactTeaser = React.lazy(() => import('../Components/Home/ContactTeaser'));
const ScrollToTopButton = React.lazy(() => import('../Components/ScrollToTopButton'))
const VideoSection = React.lazy(() => import('../Components/Home/VideoSection'))

const Home = () => {
  return (
    <>
      <CSSReset />
      <Suspense fallback={
        <Center height="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="#ec562c"
            size="xl"
          />
        </Center>
      }>
         <Header />
         <ProductsOverview />
         <VideoSection />
         <ApplicationsSection />
         <NewsOverview />

         <ContactTeaser />
         <ScrollToTopButton />
      </Suspense>
    </>
  );
};

export default Home;
